<div class="flex w-full flex-row gap-6">
  <ng-container *ngIf="languages$ | async as languages">
    <app-kiosk-language-flag-atom
      *ngFor="let language of languages"
      [languageFlagUrl]="language.flagUrl ?? ''"
      (click)="onChangeLanguage(language.locale, $event)"
    ></app-kiosk-language-flag-atom>
  </ng-container>
</div>
